import './EnceladusBackground.scss';

export const EnceladusBackground = () => {
    return (
        <div className="space">
            {/* <div className="stars" /> */}
            
            {/* <div className="light" /> */}

            <div className="encelad" />

            {/* <div className="plume" />

            <div className="overlay" />

            <div className="atmosphere" /> */}
        </div>
    );
};